import './search-form-collapsible';



// WEBPACK FOOTER //
// ./client/src/site__fus078/components/search/global-search/index.js